<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-faturamento") {
            next({ name: "relatorio-faturamento-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-faturamento") {
            this.$router.push({ name: "relatorio-faturamento-list" });
        }
    },
};
</script>